import { render, staticRenderFns } from "./TitleWithBackButton.vue?vue&type=template&id=4bfbd252"
import script from "./TitleWithBackButton.vue?vue&type=script&lang=js"
export * from "./TitleWithBackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports